import React, { useMemo } from 'react';
import { shape, string } from 'prop-types';
import Shimmer from '@magento/venia-ui/lib/components/Shimmer'; //'../Shimmer';

import { useStyle } from '@magento/venia-ui/lib/classify'; //'../../classify';

import defaultClasses from './tileList.module.css';

var TileListShimmer = function TileListShimmer(props) {
  var classes = useStyle(defaultClasses, props.classes);
  var tiles = useMemo(function () {
    return Array.from({
      length: 3
    }).fill(null).map(function (value, index) {
      return React.createElement(Shimmer, {
        width: 3,
        height: 3,
        key: "tile-".concat(index)
      });
    });
  }, []);
  return React.createElement("div", {
    className: classes.root
  }, tiles);
};

TileListShimmer.defaultProps = {
  classes: {}
};
TileListShimmer.propTypes = {
  classes: shape({
    root: string
  })
};
export default TileListShimmer;